export default __webpack_public_path__ + "static/media/TeamSnap_Icon.48817819.png";